var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6105 8.77331C14.8535 8.52814 14.8517 8.13242 14.6066 7.88943C14.3614 7.64645 13.9657 7.64821 13.7227 7.89338L12.2666 9.36252C11.6756 9.95876 11.2689 10.3678 10.9243 10.6445C10.5896 10.9133 10.3746 11.0056 10.182 11.0301C10.0611 11.0455 9.93875 11.0455 9.81783 11.0301C9.62527 11.0056 9.41025 10.9133 9.07551 10.6445C8.7309 10.3678 8.3242 9.95876 7.73325 9.36252L6.27716 7.89338C6.03417 7.64821 5.63845 7.64645 5.39329 7.88944C5.14812 8.13242 5.14636 8.52815 5.38934 8.77331L6.87166 10.2689C7.42995 10.8322 7.88624 11.2926 8.2928 11.6191C8.71557 11.9587 9.14469 12.2044 9.65978 12.2701C9.88564 12.2989 10.1142 12.2989 10.3401 12.2701C10.8551 12.2044 11.2843 11.9587 11.707 11.6191C12.1136 11.2926 12.5699 10.8322 13.1282 10.2689L14.6105 8.77331Z",
    fill: "#24262E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.47760bdeabbc204477bb64650eae9cdb.svg";
export { ForwardRef as ReactComponent };